"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = parsePhoneNumber;
var _normalizeArguments2 = _interopRequireDefault(require("./normalizeArguments.js"));
var _parsePhoneNumber_ = _interopRequireDefault(require("./parsePhoneNumber_.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function parsePhoneNumber() {
  var _normalizeArguments = (0, _normalizeArguments2["default"])(arguments),
    text = _normalizeArguments.text,
    options = _normalizeArguments.options,
    metadata = _normalizeArguments.metadata;
  return (0, _parsePhoneNumber_["default"])(text, options, metadata);
}
//# sourceMappingURL=parsePhoneNumber.js.map